import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { select } from '@ngxs/store';
import { TablerIconComponent } from 'angular-tabler-icons';
import { DatePipe } from '@angular/common';
import { $intakeRequestViewModel } from './client-intake-request.selectors';
import { IntakeStatusDisplayComponent } from '../../client-intake-page/components/intake-status-display/intake-status-display.component';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-client-intake-request',
	templateUrl: './client-intake-request.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TablerIconComponent, DatePipe, IntakeStatusDisplayComponent],
})
export class ClientIntakeRequestComponent {
	viewModel_ = select($intakeRequestViewModel);
	navigationService = inject(NavigationService);

	reviewResponses() {
		this.navigationService.goToMatter_ClientIntake_Review(
			this.viewModel_()?.intakeForm?.matterId,
		);
	}
}
